"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
function createHeaders(opts) {
    const entries = Object.keys({ ...opts })
        .filter((key) => Boolean(opts[key]))
        .reduce((obj, key) => ({ ...obj, [key]: opts[key] }), {
        "Accept-Encoding": "compress, deflate, gzip",
        "Argus-Request-ID": (0, uuid_1.v4)(),
    });
    // Alows for undefined entries gets set to a default value and false values gets removed.
    if (opts["Accept-Encoding"] === false)
        delete entries["Accept-Encoding"];
    if (opts["Argus-Request-ID"] === false)
        delete entries["Argus-Request-ID"];
    // ARGUS - 15617: This object should always exist on a request.Add gzip to headers.
    return new Headers(entries);
}
exports.default = createHeaders;
